// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","arrow":"ExpandableItemArrow__arrow--Y0","visible":"ExpandableItemArrow__visible--uX"};